// book.doctrue.in/go/:booking_id/:kind/:sig -- where the WhatsApp confirmation
// template's buttons land. The signed suffix is resolved by the API (which mints
// the booking-scoped page token) and the browser is sent on: status / manage
// stay on this site, directions go to the hospital's maps link. The patient
// never sees the API host.
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { resolvePublicGoLink } from "../lib/apis/publicBooking";

const PublicGo: React.FC = () => {
  const { booking_id = "", kind = "", sig = "" } = useParams<{ booking_id: string; kind: string; sig: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    resolvePublicGoLink(booking_id, kind, sig)
      .then(({ url }) => {
        if (cancelled) return;
        try {
          const u = new URL(url);
          if (u.origin === window.location.origin) {
            navigate(`${u.pathname}${u.search}`, { replace: true });
            return;
          }
        } catch {
          /* fall through to a full navigation */
        }
        window.location.replace(url);
      })
      .catch((e: any) => {
        if (cancelled) return;
        const msg = e?.response?.data?.error;
        setError(typeof msg === "string" ? msg : "This link is not available.");
      });
    return () => {
      cancelled = true;
    };
  }, [booking_id, kind, sig, navigate]);

  return (
    <div className="min-h-screen bg-[#F7F8FC] flex items-start justify-center px-4 py-16">
      <div className="w-full max-w-md bg-white rounded-2xl border border-doctorsBorder p-6 text-center">
        {error ? (
          <>
            <h1 className="text-lg font-bold text-modalText">Link not available</h1>
            <p className="mt-2 text-sm text-queueText">{error}</p>
            <p className="mt-3 text-[12px] text-queueText">Open the latest confirmation on WhatsApp and tap the button again.</p>
          </>
        ) : (
          <p className="text-sm text-queueText">Opening your appointment…</p>
        )}
        <p className="mt-6 text-[11px] text-queueText">Powered by DocTrue</p>
      </div>
    </div>
  );
};

export default PublicGo;
